<template>
    <div>    
       
        <el-upload :action="action" :list-type="listType"   class="upload-demo"
            multiple
            :on-preview="handlePictureCardPreview" 
            :on-remove="handleRemove" 
            :on-success="handleSuccess"
             :limit="limit"
             :accept="accept"
            :file-list="fileList"
            :on-exceed="handleExceed"
            >
            <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>  
    </div>
</template>
<script>
    
  // 导出模块
  export default {
    props:{
        limit: { type: Number, default: 1 },
        // text/picture/picture-card
        listType:{type:String,default:'picture-card'},
        // accept  指可上传的文件格式
        accept:{type:String,default:'image/png, image/jpeg,image/jpg'},
        action:localStorage.getItem("upload"),

    },
    data() {
      //数据  
      return {
        fileList:[],
        uploadData:[],
        dialogImageUrl: '',
        dialogVisible: false,

      };
    },
  
    watch:{
   url(){
     this.imageUrl = this.url
   }
  },

    methods: {
        handleExceed(files, fileList) {
        this.$message.warning(`当前限制选择 ${this.limit} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
        //  图片上传
        handleRemove(file, fileList) {
        this.uploadData = fileList
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      handleSuccess(response, file, fileList) {
        //   console.log('handleSuccess261',response,file,fileList)
        this.uploadData = fileList
        this.$emit('upload',this.uploadData)
      
      },
    },
    // 创建前状态(里面是操作)
    beforeCreate() { },
    // 创建完毕状态(里面是操作)
    created() { },
    // 挂载前状态(里面是操作)
    beforeMount() { },
    // 挂载结束状态(里面是操作)
    mounted() { },
    // 更新前状态(里面是操作)
    beforeUpdate() { },
    // 更新完成状态(里面是操作)
    updated() { },
    // 销毁前状态(里面是操作)
    beforeDestroy() { },
    // 销毁完成状态(里面是操作)
    destroyed() { }
  };
</script>

<style scoped>

</style>